<template>
  <div class="course">
    <div class="course-box" v-if="privateCourseCateList.length>0">
      <div class="home2-title">
        职业提升
        <router-link :to="'/publicCourse?courseSource=2'" class="more">查看更多</router-link>
      </div>
      <div class="private">
        <div class="cate">
          <div
            class="cate-item"
            :class="{ active: cateIdActive == index }"
            v-for="(item, index) of privateCourseCateList"
            :key="index"
            @click="privateCourseCateChange(item.cateId, index)"
          >{{ item.cateName }}</div>
        </div>
        <div class="right">
          <swiper :options="swiperOptions" class="course-banner">
            <swiper-slide v-for="(item, index) of privateCourseList" :key="index">
              <div class="course-banner-item" @click="toCourseDetail(item)">
                <div class="img-box">
                  <img
                    :src="
                      item.coursePic ||
                      '../../../../static/home2.0/picempty.png'
                    "
                    alt
                  />
                </div>
                <div class="content">
                  <p class="title">
                    <i>在线课程</i>
                    <span>{{ item.courseName }}</span>
                  </p>
                  <p class="amount">
                    <span>视频数：{{ item.ccIdCount }}</span>
                    <span>浏览量：{{ item.courseClickRate }}</span>
                  </p>
                </div>
              </div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
            <div class="swiper-button-prev swiper-button" slot="button-prev"></div>
            <div class="swiper-button-next swiper-button" slot="button-next"></div>
          </swiper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {
  getPrivateCourseCates,
} from "@/apiCloud/home";
import { getStudyCentreList } from "@/apiCloud/publicCourse";
export default {
  data() {
    return {
      swiperOptions: {
        pagination: {
          el: ".swiper-pagination", //与slot="pagination"处 class 一致
          clickable: true //轮播按钮支持点击
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      cateIdActive: 0, //已选中课程分类的ID
      privateCourseCateList: [], //私有课程分类数据
      privateCourseList: [], //私有课程轮播数据
      offlineCoursesList: [] //线下课程
    };
  },
  created() {
    this.getPrivateCourseCates();
    // this.getUnderlineCourseListFromEnterprise();
  },
  methods: {
    //   获取私有课程分类
    getPrivateCourseCates() {
      let param = {
        courseSource: 2,
        entpId: ""
      };
      getPrivateCourseCates(param).then(res => {
        if (res.code == 200) {
          this.privateCourseCateList = res.data;
          if(res.data.length<1) return;
          this.privateCourseCateChange(res.data[0].cateId, 0);
        }
      });
    },
    //点击课程分类
    privateCourseCateChange(cateId, index) {
      this.cateIdActive = index;
      let data = {
        entpId: "",
        catePatentId: cateId,
        pageNum: 1,
        pageSize: 6,
        courseSource: 2
      };
      getStudyCentreList(data).then(res => {
        if (res.code == 200) {
          this.privateCourseList = res.rows;
        }
      });
    },
    // 点击私有课程
    toCourseDetail(item) {
      let courseType = "私有课程";
      this.$router.push({
        name: "courseDetail",
        params: {
          courseId: item.courseId,
          packagebagId: item.packagebagId,
          oldPage: 1,
          courseType
        }
      });
      localStorage.setItem("packagebagId", item.packagebagId);
      localStorage.setItem("courseId", item.courseId);
      localStorage.setItem("courseType", courseType);
    },
    //   获取线下课程
    getUnderlineCourseListFromEnterprise() {
      let data = {
        pageNum: 1,
        pageSize: 3,
        orderby: 0
      };
      getUnderlineCourseListFromEnterprise(data).then(res => {
        if (res.code == 200) {
          let rows = res.rows;
          this.offlineCoursesList = res.rows;
        }
      });
    },
    // 点击线下课程
    toOffline(id) {
      this.$router.push("offlineCourseDetail?courseId=" + id);
    }
  }
};
</script>


<style lang="less"  src="./public.less" scoped></style>
<style lang="less" scoped>
.course {
  .course-box {
    width: 1200px;
    margin: 20px auto 0;
    box-sizing: border-box;
    background: #fff;
    padding: 0 24px;
    box-sizing: border-box;
    .home2-title {
      background-image: url("../../../../static/home2.0/icon-course1.png");
      &.icon-line {
        background-image: url("../../../../static/home2.0/icon-course2.png");
      }
      .more {
        display: block;
        position: absolute;
        right: 0;
        top: 0;
        color: #666;
        font-size: 16px;
        padding-right: 20px;
        font-weight: normal;
        background: url("../../../../static/home2.0/icon-more.png") no-repeat
          center right;
        cursor: pointer;
        &:hover {
          color: #3482ff;
        }
      }
    }
    .private {
      margin-top: 25px;
      display: flex;
      justify-content: space-between;
      .cate {
        width: 240px;
        height: 600px;
        background-color: #f4f4f4;

        .cate-item {
          position: relative;
          height: 60px;
          line-height: 60px;
          font-size: 16px;
          color: #666666;
          padding-left: 20px;
          box-sizing: border-box;
          cursor: pointer;
          &.active {
            color: #3482ff;
            font-weight: bold;
            background-color: #e8f4ff;
          }
          &:before {
            display: block;
            content: "";
            position: absolute;
            width: 0;
            height: 2px;
            background: #3482ff;
            right: 50%;
            bottom: 0;
            transition: all 0.3s;
          }
          &:after {
            display: block;
            content: "";
            position: absolute;
            width: 0;
            height: 2px;
            background: #3482ff;
            left: 50%;
            bottom: 0;
            transition: all 0.3s;
          }
          &:hover {
            &:before {
              width: 50%;
            }
            &:after {
              width: 50%;
            }
          }
        }
      }
    }

    .right {
      width: 916px;
      height: 609px;
      padding: 40px 113px;
      box-sizing: border-box;
      .course-banner {
        position: relative;
        .course-banner-item {
          cursor: pointer;
          .img-box {
            height: 460px;
            overflow: hidden;
            img {
              display: block;
              width: 100%;
              min-height: 100%;
            }
          }
          .content {
            position: relative;
            top: -35px;
            width: 620px;
            height: 106px;
            margin: 0 auto;
            background-color: #fff;
            padding: 0 29px;
            padding-top: 30px;
            box-sizing: border-box;
            .title {
              color: #333;
              font-size: 16px;
              display: flex;
              align-items: center;
              i {
                width: 54px;
                height: 20px;
                line-height: 20px;
                text-align: center;
                background: #ffffff;
                border: 1px solid #1c6bff;
                border-radius: 2px;
                margin-right: 12px;
                font-size: 11px;
                color: #1c6bff;
              }
              span {
                flex: 1;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
            .amount {
              margin-top: 12px;
              color: #b3b3b3;
              font-size: 14px;
              span {
                padding-right: 30px;
              }
            }
          }
        }

        .swiper-button {
          top: 502px;
          &:after {
            font-size: 20px;
          }
          &.swiper-button-prev {
            left: 560px;
          }
          &.swiper-button-next {
            right: 65px;
          }
        }
        .swiper-pagination {
          bottom: 150px;
          /deep/ .swiper-pagination-bullet {
            width: 12px;
            height: 12px;
            border: 1px solid #ffffff;
            background: none;
            &.swiper-pagination-bullet-active {
              background: #fff;
            }
          }
        }
      }
    }

    .offline {
      display: flex;
      margin: 24px 0;
      padding-bottom: 30px;
      .course-card {
        width: 367px;
        position: relative;
        cursor: pointer;
        box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.1);
        &:not(:first-child) {
          margin-left: 26px;
        }
        .img-box {
          height: 245px;
          overflow: hidden;
          img {
            display: block;
            width: 100%;
            min-height: 100%;
          }
        }
        .content {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 80px;
          background: rgba(0, 0, 0, 0.3);
          padding: 0 20px;
          padding-top: 17px;
          box-sizing: border-box;
          .title {
            color: #fff;
            font-size: 20px;
            display: flex;
            align-items: center;
            i {
              width: 54px;
              height: 20px;
              line-height: 20px;
              text-align: center;
              border: 1px solid #fff;
              border-radius: 2px;
              margin-right: 12px;
              font-size: 11px;
              color: #fff;
            }
            span {
              flex: 1;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          .amount {
            margin-top: 8px;
            color: #fff;
            font-size: 14px;
            span {
              padding-right: 30px;
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Home3.0/src/CoursePrivate.vue